import { toastr } from 'react-redux-toastr'

// eslint-disable-next-line import/no-anonymous-default-export
export default ({ dispatch }) =>
  (next) =>
  (action) => {
    if (
      action.type &&
      action.type.endsWith('FAILURE') &&
      action.err?.name !== 'AbortError'
    ) {
      toastr.error('Operation Fail', 'Fail to connect to the service.')
      console.log(action.err)
    }

    return next(action)
  }
